import domReady from '@wordpress/dom-ready';

//insert banner in results list
const searchResultsBanner = () => {
  const findstrResultItems = document.querySelectorAll(
    '.findstr-search-result-item:not(.search-result-item--banner)'
  );

  const resultsBanner = document.querySelector(
    '.findstr-results[data-findstr-results="resultsearch"] .search-result-item--banner'
  );

  if (resultsBanner) {
    resultsBanner.remove();
    //if results items number < or = 4, insert banner at the end of the list
    // else insert it after the fourth item
    if (findstrResultItems.length) {
      if (4 >= findstrResultItems.length) {
        findstrResultItems[findstrResultItems.length - 1].after(resultsBanner);
      } else if (4 < findstrResultItems.length) {
        findstrResultItems[3].after(resultsBanner);
      }

      resultsBanner.style.display = 'flex';
    }
  }
};

//re-call banner insertion function when findstr results list reload
const reloadBannerOnRefresh = () => {
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector(
    '.findstr-results[data-findstr-results="resultsearch"]'
  );
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if ('childList' === mutation.type) {
        observer.disconnect(); // Déconnecte l'observateur
        searchResultsBanner();
        observer.observe(targetNode, config); // Reconnecte l'observateur
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
};

/////////////// ON READY /////////////////
domReady(() => {
  const searchResultsPage = document.querySelector('body.search-results');
  if (searchResultsPage) {
    searchResultsBanner();
    reloadBannerOnRefresh();
  }
});
